import { render, staticRenderFns } from "./inspection.vue?vue&type=template&id=ac640582&scoped=true"
import script from "./inspection.vue?vue&type=script&lang=ts"
export * from "./inspection.vue?vue&type=script&lang=ts"
import style0 from "./inspection.vue?vue&type=style&index=0&id=ac640582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac640582",
  null
  
)

export default component.exports